import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    private isAuthorized : boolean = false;
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.isAuthorized = false;
        if (this.authService.user) {
            if (route.data.roles) {
                // if a route requires roles, check to see if the user has the role
                route.data.roles.forEach(role => {
                    if (this.authService.isInRole(role))
                        this.isAuthorized = true;
                })
            }
            else {
                this.isAuthorized = true;
                //this.router.navigate(route.url);
            }
        }
        return this.isAuthorized;


        // not logged in so redirect to login page with the return url
    }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/auth.guard.ts